import { Configurator, ConfiguratorForm } from './types'

export const calculateTotalScore = (
  sections: ConfiguratorForm['sections'],
  configurator: Configurator['sections'],
) => {
  const scores = sections.map((section, i) =>
    section.questions.map((answerVal, j) => {
      const answer = configurator[i].questions[j].answers[answerVal - 1]
      const isAgeQuestion = configurator[i].questions[j].questionVariant === 'ageSlider'
      if (isAgeQuestion) return 0

      return answer.score
    }),
  )

  const totalScore = scores.flat().reduce((acc, score) => acc + score, 0)
  return totalScore
}

export const findAgeQuestion = (sections: Configurator['sections']) =>
  sections
    .find((section) => section.questions.some((q) => q.questionVariant === 'ageSlider'))
    ?.questions.find((q) => q.questionVariant === 'ageSlider')
